import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { BoxDanger, BoxInfo, BoxSuccess, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { examHelper, examService, learningService, networkErrorHelper } from "libs";
import { Button, Icon, Row, Col } from "design-react-kit";
import { COMPANY, REVISOR_CONTEXTS, ROUTES } from "const";
import { FormEnabler, MLabel, MTextArea, ValidatedForm } from "components/forms";

import ReactHtmlParser from "react-html-parser";
import { tfaIndireExamService } from "libs/api";

class TFAIndireExamWritten extends ValidatedForm {
  emptyFields = {
    titolo: "",
    riflessioneCaso: "",
    quadroTeorico: "",
    scelteMetodologiche: "",
    usoRisorse: "",
    considerazioniConclusive: "",
  };

  state = {
    loading: true,
    loadingError: false,
    showSuccess: false,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    examQuestion: [],
    rCode: this.props.match.params.rCode,
    exam: {},
    examRevision: {},
    examReservation: {},
    course: {},
  };

  FIELDS_GROUP = [
    [
      {
        label: "Titolo",
        for: "titolo",
        infoText: "<b>(massimo 200 caratteri spazi inclusi).</b>",
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "titolo",
        question: "Titolo",
        component: MTextArea,
        className: "col-md-12",
        rows: 5,
        maxLen: 200,
      },
    ],
    [
      {
        label:
          "Riflessione su un caso di studio: episodio significativo vissuto in ambito scolastico",
        for: "riflessioneCaso",
        infoText: "<b>(min. 4.500 max 5.000 caratteri spazi inclusi).</b>",
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "riflessioneCaso",
        question:
          "Riflessione su un caso di studio: episodio significativo vissuto in ambito scolastico",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        minLen: 4500,
        maxLen: 5000,
      },
    ],
    [
      {
        label: "Quadro teorico e normativo di riferimento ",
        for: "quadroTeorico",
        infoText: `<b>(min. 3.500 max 4.000 caratteri spazi inclusi);</b>`,
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "quadroTeorico",
        question: "Quadro teorico e normativo di riferimento ",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        minLen: 3500,
        maxLen: 4000,
      },
    ],
    [
      {
        label: "Scelte metodologico-didattiche adottate",
        for: "scelteMetodologiche",
        infoText: "<b>(min. 1.500 max 3.000 caratteri spazi inclusi);</b>",
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "scelteMetodologiche",
        question: "Scelte metodologico-didattiche adottate",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        minLen: 1500,
        maxLen: 3000,
      },
    ],
    [
      {
        label:
          "Uso di risorse e strumenti digitali che favoriscono l’inclusione",
        for: "usoRisorse",
        infoText: "<b>(min. 1.500 max 2.000 caratteri spazi inclusi);</b>",
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "usoRisorse",
        question:
          "Uso di risorse e strumenti digitali che favoriscono l’inclusione",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        minLen: 1500,
        maxLen: 2000,
      },
    ],
    [
      {
        label: "Considerazioni conclusive",
        for: "considerazioniConclusive",
        infoText: "<b>(min. 500 max 1.500 caratteri spazi inclusi);</b>",
        component: MLabel,
        className: "col-md-12 pt-4",
      },
    ],
    [
      {
        field: "considerazioniConclusive",
        question: "Considerazioni conclusive",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        minLen: 500,
        maxLen: 1500,
      },
    ],
  ];

  MAX_LEN = {
    titolo: 200,
    riflessioneCaso: 5000,
    quadroTeorico: 4000,
    scelteMetodologiche: 3000,
    usoRisorse: 2000,
    considerazioniConclusive: 1500,
  };

  ERROR_MESSAGES = {
    titolo: `Il campo Titolo è obbligatorio e non può superare i ${this.MAX_LEN["titolo"]} caratteri.`,
    riflessioneCaso: `Il campo Riflessione su un caso di studio è obbligatorio e deve essere compreso tra ${this.MAX_LEN["riflessioneCaso"] - 500
      } e ${this.MAX_LEN["riflessioneCaso"]} caratteri.`,
    quadroTeorico: `Il campo Quadro teorico e normativo di riferimento è obbligatorio e deve essere compreso tra ${this.MAX_LEN["quadroTeorico"] - 500
      } e ${this.MAX_LEN["quadroTeorico"]} caratteri.`,
    scelteMetodologiche: `Il campo Scelte metodologico-didattiche adottate è obbligatorio e deve essere compreso tra ${this.MAX_LEN["scelteMetodologiche"] - 1500
      } e ${this.MAX_LEN["scelteMetodologiche"]} caratteri.`,
    usoRisorse: `Il campo Uso di risorse e strumenti digitali che favoriscono l’inclusione è obbligatorio e deve essere compreso tra ${this.MAX_LEN["usoRisorse"] - 500
      } e ${this.MAX_LEN["usoRisorse"]} caratteri.`,
    considerazioniConclusive: `Il campo Considerazioni conclusive è obbligatorio e deve essere compreso tra ${this.MAX_LEN["considerazioniConclusive"] - 1000
      } e ${this.MAX_LEN["considerazioniConclusive"]} caratteri.`,
  };

  validation = {
    titolo: (value) => value !== "" && value.length < this.MAX_LEN["titolo"],
    riflessioneCaso: (value) =>
      value !== "" &&
      value.length >= this.MAX_LEN["riflessioneCaso"] - 500 &&
      value.length <= this.MAX_LEN["riflessioneCaso"],
    quadroTeorico: (value) =>
      value !== "" &&
      value.length >= this.MAX_LEN["quadroTeorico"] - 500 &&
      value.length <= this.MAX_LEN["quadroTeorico"],
    scelteMetodologiche: (value) =>
      value !== "" &&
      value.length >= this.MAX_LEN["scelteMetodologiche"] - 1500 &&
      value.length <= this.MAX_LEN["scelteMetodologiche"],
    usoRisorse: (value) =>
      value !== "" &&
      value.length >= this.MAX_LEN["usoRisorse"] - 500 &&
      value.length <= this.MAX_LEN["usoRisorse"],
    considerazioniConclusive: (value) =>
      value !== "" &&
      value.length >= this.MAX_LEN["considerazioniConclusive"] - 1000 &&
      value.length <= this.MAX_LEN["considerazioniConclusive"],
  };

  constructor(props) {
    super(props);
    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  goBack() {
    window.history.back();
  }

  onCancel = () => {
    this.setState({
      validationSummary: "",
    });

    this.resetForm();
  };

  componentDidMount() {
    this.loadRemoteDashboard(this.state.rCode);
    this.loadRemote(this.state.rCode);
  }

  loadRemoteDashboard(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({
          course,
          userCourse,
          loading: false,
          loadingError: false,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false, loadingError: true });
      });
  }

  loadRemote(rCode) {
    this.setState({ loading: true, loadingError: false, rCode });

    tfaIndireExamService
      .myExamReservation(rCode, 'tfaindire_laboratori')
      .then((data) => {
        const { examReservation } = data.data.payload;
        this.setState({ examReservation });

        // load paylods to fill the select options
        this.loadRemoteExam(rCode);
      })
      .catch((errors) => {
        this.setState({ loading: false, loadingError: true });
        networkErrorHelper.notify(errors);
      });

  }

  loadRemoteExam(rCode) {
    examService
      .getExamByRCode(rCode)
      .then((data) => {
        const { exam, examQuestion, examRevision } = data.data.payload;

        let defaultValues = {};
        examQuestion.map((item) => {
          defaultValues[item.field] = item.answer;
          examQuestion[item.field] = { ...item, value: item.answer };
        });

        this.setState({
          defaultValues,
          examQuestion,
          examRevision,
          rCode,
          loading: false,
          loadingError: false,
          exam,
        });
      })
      .catch((errors) => {
        this.setState({ loading: false });
      });
  }

  /** */
  onSubmit = () => {
    this.setState({ loading: true, loadingError: false });

    /** save remote */
    this.setState({ registrationCode: this.state.rCode });
    let payload = {
      exam: {},
      examQuestion: [],
    };

    let progress = 1;

    //--- prepare examQuestion data ---
    this.FIELDS_GROUP.map((group) => {
      if (group[0].field) {
        let data = {
          field: group[0].field,
          question: group[0].question,
          answer: this.state[group[0].field]?.value || "",
          progress: progress++,
        };

        if (typeof this.state.exam.id !== "undefined") {
          const examQuestionObj = this.state.examQuestion;
          const examQuestionArray = Object.keys(examQuestionObj).map(
            (key) => examQuestionObj[key]
          );
          data.id = examQuestionArray.filter(
            (item) => item.field === group[0].field
          )[0]?.id;
        }

        payload.examQuestion.push(data);
      }
    });

    //--- handle draft mode ---
    if (typeof this.state.exam.id === "undefined") {
      payload.exam = {
        registrationCode: this.state.rCode,
        status: "draft",
        context: REVISOR_CONTEXTS.TFAINDIRE,
      };

      this.saveRemote(payload);
    } else {
      payload.exam = {
        ...this.state.exam,
      };

      payload.examQuestion = payload.examQuestion.map((item) => {
        const existingItem = this.state.examQuestion.find(
          (eq) => eq.field === item.field
        );

        if (existingItem) {
          if (item.answer !== "") {
            existingItem.answer = item.answer;
          } else {
            item.answer = existingItem.answer;
          }
        }

        return item;
      });

      this.setState({
        loading: false,
        loadingError: false,
      });

      this.updateRemote(payload);
    }

    setTimeout(() => {
      this.loadRemoteExam(this.state.rCode);
    }, 500);
  };

  /** */
  saveRemote(payload) {
    examService
      .examInsertTFA(payload)
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
          showSuccess: true,
          exam: { ...data.data.payload.resExam },
          examQuestion: { ...data.data.payload.resExamQuestion },
        });

        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 4000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  updateRemote(payload) {
    examService
      .examUpdate(payload)
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
          showSuccess: true,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 4000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  confirmExam = (e, value) => {
    ModalHandler.show(
      value,
      "Conferma Elaborato",
      "Vuoi confermare l'invio dell'elaborato? La conferma dell'elaborato non potrà essere più modificata.",
      null,
      this.onConfirm,
    );
  }; //deleteRecord

  onConfirm = (value) => {
    this.setState({
      loading: true,
      loadingError: false,
    });

    let isValidForm = this.checkValidation();
    if (!isValidForm) {
      this.setState({ loading: false });
      return true;
    }

    this.onSubmit();

    examService
      .confirmTFAIndireExamWritten({ ...this.state.exam, status: "confirmed" })
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
        });

        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 1000);

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  //---
  downloadPDF = () => {
    const { rCode } = this.state;
    this.setState({ loading: true });

    examService
      .downloadPdfExamWritten(rCode)
      .then(({ data }) => {
        let loadingError = "";

        if (data.payload && data.payload.udaPayload) {
          window.open(data.payload.udaPayload.location, "_blank");
        } else {
          loadingError =
            "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. ";
        }

        this.setState({ loading: false, loadingError });
      })
      .catch((error) => {
        console.log(error);
        const requestError =
          "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. Dettagli errore: " +
          networkErrorHelper.getErrorMessage(error);
        this.setState({ loading: false, loadingError: requestError });
      });
  };

  renderEdit() {
    const { defaultValues, showSuccess, exam, examRevision, examReservation, rCode } = this.state;
    let isPending = false;

    // if can edit is false, render read only
    const canEdit = examHelper.canEditSubject(examReservation?.date, 0, "18:00", rCode);

    if (!canEdit) {
      if (exam.status === "revisionPending") {
        return (
          <>
            <BoxDanger>
              Gentile Docente, non avendo revisionato l'elaborato in base alle indicazioni fornite, 
              Le sarà possibile consegnarlo direttamente alla Commissione il giorno dell'esame.<br />
              Per qualsiasi ulteriore chiarimento, La invitiamo a <SupportoTecnico />
            </BoxDanger>
          </>
        );
      } else {
        return (
          <>
            <BoxDanger>
              Gentile Docente, non avendo svolto l'elaborato, Le sarà
              possibile consegnarlo direttamente alla Commissione il giorno dell'esame.<br />
              Per qualsiasi ulteriore chiarimento, La invitiamo a <SupportoTecnico />
            </BoxDanger>
          </>
        );
      }
    }

    if (exam && exam.status === "revisionPending") {
      isPending = true;
    }

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <div className="container">
          {showSuccess && (
            <div className="Container">
              <BoxSuccess className="mt-4">
                Elaborato salvato con successo!
              </BoxSuccess>
            </div>
          )}
          {isPending && (
            <MnemoCallout className="mnemo-callout-danger w-100">
              <h5 className="text-red">ATTENZIONE: ELABORATO NON IDONEO</h5>
              <p>
                L'elaborato non risulta idoneo. La invitiamo a modificare
                l'elaborato, nel rispetto delle motivazioni di seguito
                riportate, e premere il tasto{" "}
                <b>
                  Conferma Elaborato<b></b>
                </b>
              </p>
              <p>
                {" "}
                <i>{examRevision.revisionNote}</i>
              </p>
            </MnemoCallout>
          )}
          <form>
            {code}

            <Row className="my-5">
              <FormEnabler
                onSubmit={this.onSubmit}
                onCancel={this.onCancel}
                isFormActive={true}
                buttonText="Salva Modifiche"
              />

              {parseInt(exam.id) > 0 && (
                <Button
                  color="primary bg-dark"
                  onClick={() => {
                    this.confirmExam();
                  }}
                >
                  Consegna Elaborato
                </Button>
              )}
            </Row>
            <Row>
              <Col xs="12">
                <MnemoCallout title="Note per la compilazione">
                  <hr />
                  <ul>
                    <li>
                      Le modifiche correnti saranno salvate solo premendo il
                      tasto <b>Salva Modifiche</b>. Si possono apportare diverse
                      modifiche memorizzandole tramite il tasto{" "}
                      <b>Salva Modifiche</b> per memorizzare le modifiche
                      apportate.
                    </li>
                    <li>
                      Le modifiche salvate verranno memorizzate e sarà possibile
                      continuare la compilazione dell'elaborato anche in un
                      secondo momento.
                    </li>
                    <li>
                      Premendo il tasto <b>Consegna Elaborato</b> l'elaborato
                      verrà inviato e non potrà più essere modificato. Potrà
                      solo essere consultato e scaricato fino al giorno
                      dell'esame.
                    </li>
                    <li>
                      In caso di non idoneità dell'elaborato riceverà un avviso
                      con i motivi specifici affinché possa, tempestivamente,
                      procedere ad apportare le modifiche necessarie per rendere
                      l'elaborato idoneo alla valutazione da parte della
                      Commissione.
                    </li>
                    <li>
                      In caso di mancata consegna, entro i termini previsti
                      tramite il tasto <b>Consegna Elaborato</b> il sistema
                      acquisirà autonomamente e senza ulteriore avviso il lavoro
                      svolto fino a quel momento.
                    </li>
                  </ul>
                </MnemoCallout>
              </Col>
            </Row>
          </form>
        </div>
      </>
    );
  }

  renderRead() {
    const { examQuestion } = this.state;

    return (
      <>
        <BoxSuccess className="mt-4">
          Elaborato consegnato. Non è possibile modificare i dati.
          <Button
            onClick={this.downloadPDF}
            color="primary bg-dark"
            className="mx-5"
          >
            Scarica PDF
          </Button>
        </BoxSuccess>
        {this.FIELDS_GROUP.map((rowFields, i) => {
          return rowFields.map((field, j) => {
            if (field.for) {
              const question = examQuestion.filter(
                (item) => item.field === field.for
              )[0];

              return (
                <Row key={j}>
                  <MnemoCallout
                    className="mnemo-callout-info w-100"
                    title={field.label}
                  >
                    <p>
                      <i>{ReactHtmlParser(field.infoText)}</i>
                    </p>
                    <hr />
                    <p>
                      {question && (
                        <>
                          {question.field === "examSubject" ? (
                            <>{this.state.examSubjectLabel}</>
                          ) : (
                            <>{question.answer}</>
                          )}
                        </>
                      )}
                    </p>
                  </MnemoCallout>
                </Row>
              );
            }
          });
        })}
      </>
    );
  }

  renderNoteTFAINDIRE() {
    return (
      <BoxInfo className="mt-4">
        <p> <b> </b> </p>
        <ul>
          <li> </li>
        </ul>
      </BoxInfo>
    );
  }

  render() {
    const { loading, loadingError, rCode, exam, course } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError) {
      return (
        <BoxDanger className="mt-4">
          Si è verificato un errore durante il caricamento della pagina,
          <br />
          <SupportoTecnico />
        </BoxDanger>
      );
    }

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" />
          TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Elaborato su un caso di studio</Title>
        <hr />
        {course.instituteCompany === COMPANY.IUL && this.renderNoteTFAINDIRE()}
        {exam && (
          <>
            {exam.status === "confirmed" || exam.status === "revisioned"
              ? this.renderRead()
              : this.renderEdit()}
          </>
        )}
      </>
    );
  }
}

export default withRouter(TFAIndireExamWritten);
